export const ADD_POKEMON_TO_WISHLIST_REQUEST = 'ADD_POKEMON_TO_WISHLIST_REQUEST';
export const ADD_POKEMON_TO_WISHLIST_SUCCESS = 'ADD_POKEMON_TO_WISHLIST_SUCCESS' ;
export const ADD_POKEMON_TO_WISHLIST_FAIL = 'ADD_POKEMON_TO_WISHLIST_FAIL';
export const ALREADY_ADDED_TO_WISHLIST_SUCCESS = 'ALREADY_ADDED_TO_WISHLIST_SUCCESS';
export const ALREADY_ADDED_TO_WISHLIST_FAIL = 'ALREADY_ADDED_TO_WISHLIST_FAIL';


export const REMOVE_FROM_WISHLIST_SUCCESS = 'REMOVE_FROM_WISHLIST_SUCCESS';
export const REMOVE_FROM_WISHLIST_FAIL ='REMOVE_FROM_WISHLIST_FAIL';

export const ADD_POKEMON_TO_CART_REQUEST = 'ADD_POKEMON_TO_CART_REQUEST';
export const ADD_POKEMON_TO_CART_SUCCESS = 'ADD_POKEMON_TO_CART_SUCCESS' ;
export const ADD_POKEMON_TO_CART_FAIL = 'ADD_POKEMON_TO_CART_FAIL';

export const REMOVE_POKEMON_FROM_CART_SUCCESS = 'REMOVE_POKEMON_FROM_CART_SUCCESS';
export const REMOVE_POKEMON_FROM_CART_FAIL = 'REMOVE_POKEMON_FROM_CART_FAIL';


export const CLEAR_ERRORS = 'CLEAR_ERRORS';
